const ourfetch = require('isomorphic-fetch')

const buildUrl = require('airship/modules/request2/utils/build-url')
const normalizeHeaders = require('airship/modules/request2/utils/normalize-headers')

module.exports = request
module.exports.get = getRequest
module.exports.post = postRequest
module.exports.put = putRequest
module.exports.patch = patchRequest
module.exports.delete = deleteRequest

function request(options) {
  const finalUrl = buildUrl(options)
  const method = (options.method || 'get').toUpperCase()
  const headers = normalizeHeaders(options.headers || {})

  // We default to this so that cookies will get passed along.
  const credentials = options.credentials || 'same-origin'
  const redirect = options.redirect || 'follow'

  let body = options.body || ''

  if (method === 'GET' || method === 'HEAD') {
    body = void 0
  }
  headers.accept = headers.accept || 'application/json'

  const requestOpts = {
    method,
    headers,
    body,
    credentials,
    redirect,
  }

  return new Promise(makeRequest)

  function makeRequest(resolve, reject) {
    const response = {
      statusCode: -1,
      headers: {},
      body: '',
      requestId: options.requestId, // pass through request id, if it exists
    }

    ourfetch(finalUrl, requestOpts)
      .then((resp) => {
        response.statusCode = resp.status
        response.headers = resp.headers
        return resp.text()
      })
      .then((body) => {
        response.body = body
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  }
}

function getRequest(options) {
  options.method = 'get'
  return request(options)
}

function postRequest(options) {
  options.method = 'post'
  return request(options)
}

function putRequest(options) {
  options.method = 'put'
  return request(options)
}

function patchRequest(options) {
  options.method = 'patch'
  return request(options)
}

function deleteRequest(options) {
  options.method = 'delete'
  return request(options)
}
